import { render, staticRenderFns } from "./Storagestatus.vue?vue&type=template&id=6cd2a06e&scoped=true&"
import script from "./Storagestatus.vue?vue&type=script&lang=js&"
export * from "./Storagestatus.vue?vue&type=script&lang=js&"
import style0 from "./Storagestatus.vue?vue&type=style&index=0&id=6cd2a06e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd2a06e",
  null
  
)

export default component.exports